import { http } from './client';

export interface ClientOnboardingAlert {
  pending: boolean;
  urgent: boolean;
  daysUntilStart: number;
  companies: Array<{ clientId: string | null; companyName: string; complete: boolean; missing: string[] }>;
  reasons: string[];
}
export interface ClientOnboardingShowAlert {
  eventId: string;
  eventName: string;
  clientOnboarding: ClientOnboardingAlert;
}
export async function loadUrgentClientOnboarding(): Promise<{ shows: ClientOnboardingShowAlert[]; truncated: boolean }> {
  const { response, error } = await http({ method: 'GET', url: 'dashboard/client-onboarding', isToken: true });
  if (error) throw error;
  const data = response?.data?.data ?? response?.data;
  return { shows: Array.isArray(data?.shows) ? data.shows : [], truncated: data?.truncated === true };
}
